import { useState } from 'react';

const FAQS = [
  {
    q: 'AI 功能完全免費嗎？',
    a: '是的，所有 AI 功能對所有用戶完全免費，包含 AI 智能配對、標題生成、文案撰寫、實價查詢等。我們的核心理念是讓科技普惠每個租屋人。',
  },
  {
    q: 'AI 配對的準確率有多高？',
    a: 'AI 配對系統綜合分析地點偏好、預算範圍、房型需求、生活習慣等多項維度，針對每個需求給出 0-100% 的配對分數。高於 80% 的配對通常代表雙方需求高度吻合，實際看房轉化率顯著提升。',
  },
  {
    q: '租客審核功能會如何保護隱私？',
    a: 'AI 租客審核僅分析用戶在平台上的互動紀錄（如留言內容、回應速度）與自填基本資訊，不涉及任何個人身份證或財務資料查詢，完全符合台灣個人資料保護法規範。',
  },
  {
    q: '需要下載 App 才能使用嗎？',
    a: '不需要！藍舍 AI 地產是純網頁平台，電腦、平板、手機瀏覽器都可以直接使用全部功能，無需下載任何應用程式，免安裝、免更新。',
  },
  {
    q: 'AI 生成的標題和文案可以修改嗎？',
    a: '當然可以！AI 生成的所有內容（標題、推廣文案）都只是參考初稿，你可以自由編輯修改後再發布，AI 幫你快速起稿，最終決定權始終在你手上。',
  },
  {
    q: 'Threads / Facebook 自動發布需要授權嗎？',
    a: '是的，首次使用社群自動發布功能前，需要授權連結你的 Threads 或 Facebook 帳號。授權完成後，後續可直接在平台一鍵發布或設定排程，無需再重複操作。',
  },
];

export default function AiFaq() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="max-w-3xl mx-auto px-4 pb-16">
      <div className="text-center mb-8">
        <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-white/6 border border-white/10 rounded-full text-[10px] font-bold text-white/50 mb-3">
          <i className="ri-question-answer-line text-xs"></i>
          常見問題
        </div>
        <h2 className="text-xl md:text-2xl font-black text-white">你可能想知道</h2>
      </div>

      <div className="space-y-2">
        {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return (
            <div
              key={i}
              className={`rounded-2xl border overflow-hidden transition-all duration-300 ${isOpen ? 'border-teal-500/30 bg-teal-500/6' : 'border-white/8 bg-white/3 hover:border-white/15'}`}
            >
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : i)}
                className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left cursor-pointer"
              >
                <span className={`text-sm font-semibold leading-snug transition-colors ${isOpen ? 'text-teal-300' : 'text-white/80'}`}>
                  {faq.q}
                </span>
                <i className={`ri-arrow-down-s-line text-base flex-shrink-0 transition-all duration-300 ${isOpen ? 'rotate-180 text-teal-400' : 'text-white/25'}`}></i>
              </button>
              <div
                className="overflow-hidden transition-all duration-300"
                style={{ maxHeight: isOpen ? '200px' : '0px' }}
              >
                <p className="px-5 pb-5 text-sm text-white/50 leading-relaxed">{faq.a}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
